import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { BaseDataSource } from "../../_base/crud";
import { selectAssetClassRetailBuildingInStore, selectAssetClassRetailBuildingPageLoading, selectAssetClassRetailBuildingShowInitWaitingMessage } from "../_selectors/asset-class-retail-building.selectors";
import { tenureAdder } from "./tenure_extension";

export class AssetClassRetailBuildingDataSource extends BaseDataSource {
    trashed = 0;

    constructor(
        private store: Store<AppState>
    ) {
        super();

        this.loading$ = this.store.pipe(
            select(selectAssetClassRetailBuildingPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectAssetClassRetailBuildingShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectAssetClassRetailBuildingInStore)
        ).subscribe(response => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.trashed = response.trashed;
            this.entitySubject.next(response.items.map(e => tenureAdder(e)));
        })
    }
}